<template>
  <div class="preview" @touchmove.capture="dialogTouchMove($event)">
    <div class="mask" :style="{opacity: maskOpacity}" @click="close"></div>
    <div class="close-icon" @click="close"><i class="iconfont icon-close"></i></div>
    <div class="img-main" @click="close">
      <img
        :src="imgSrc"
        :class="{
          'fill': modelType === 'fill',
          'fit-content': modelType === 'fit-content'
        }"
        alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    modelType: {
      type: String,
      default: ''
    },
    maskOpacity: {
      type: [Number, String],
      default: 1
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    dialogTouchMove (e) {
      e.preventDefault()
    }
  }
}
</script>

<style scoped>
  .preview{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }
  .mask{
    background: #000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    opacity: 1;
    animation-fill-mode: backwards;
    animation: opacityAnim .2s ease-in;
  }
  .close-icon{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 35px;
    height: 35px;
    line-height: 35px;
    border: 1px solid #ccc;
    color: #ccc;
    text-align: center;
    border-radius: 50%;
    z-index: 10001;
  }
  .img-main{
    z-index: 10000;
    box-sizing: border-box;
    padding: 5% 5%;
    max-height: 100%;
    text-align: center;
    overflow-y: scroll;
    animation-fill-mode: backwards;
    animation: opacityAnim .2s ease-in;
  }
  .img-main img{
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .img-main .fill{
    height: -webkit-fill-available;
  }
  .img-main .fit-content{
    height: fit-content;
  }
</style>
